// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { dateSchema } from "../commonSchemas";

export const path = "get-invoices";

export const invoiceSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: dateSchema,
  dueDate: dateSchema,
  amountCents: z.number().int(),
  otherPartyName: z.string(),
  status: z.enum(["Pending", "Paid", "Overdue"]),
});

export const getInvoicesResponseSchema = z.object({
  receivedInvoices: z.array(invoiceSchema),
});




export type GetInvoicesResponse = z.infer<typeof getInvoicesResponseSchema>;

export type Invoice = z.infer<typeof invoiceSchema>;




// receiver/get-invoices endpoint
export function getInvoices(
): Promise<GetInvoicesResponse> {
  return requestHandler(
    "receiver/get-invoices",
    undefined,
    getInvoicesResponseSchema,
  );
}

